export default "__VITE_ASSET__BCkl9GSm__"